// removed by extract-text-webpack-plugin
module.exports = {"date":"date__2aZEJ","divider":"divider__26wwI"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleDetail/styles/DateRenderer.scss
// module id = Znd3
// module chunks = 1